import Com from "components/styledComp/CommStyledComp";
import React, { useState } from "react";
import sPedestal_외형 from "assets/images/sPedestal_외형.png"
import sPedestal_장착사례_국산 from "assets/images/sPedestal_장착사례_국산.png"
import sPedestal_장착사례_외산 from "assets/images/sPedestal_장착사례_외산.png"
import Modal from "./Modal";

const SpdstDetail = () => {
    const [showModal, setShowModal] = useState(false);

    const handleImgClick = (imgSrc) => {
        setShowModal(imgSrc);
    };

    const imgList = [
        { 
            imgUrl: sPedestal_외형, 
            title: "외형" 
        }, 
        {
            imgUrl: sPedestal_장착사례_국산, 
            title: "장착사례 1(국산)" 
        },    
        { 
            imgUrl: sPedestal_장착사례_외산, 
            title: "장착사례 1(외산)" 
        }];

    return (
        <Com.DivDetailSection3 border={true}>
        <div className="strategy">
            <Com.StrongStrategy>sDevice의 특징</Com.StrongStrategy>
        </div>
        <div className="pedestal-descbox">
            <div className="pedestal-parabox">
            <ul>
                <li>
                다양한 페데스탈(TallyKey/m-Tech/Rolec/Marine Planet 등)과 호환 설치 가능
                </li>
                <li>인증된 무선 통신방식의 사용으로 안정성 확보</li>
                <li>
                선석관리 시스템등과의 연계, 데시보드를 활용한 용이한 관리, 키오스크
                시스템과 연계를 통한 업무 부하 감소
                </li>
                <li>
                완벽한 한글 지원(경고 SMS - 플러그빠짐, 과금 내역, 잔액 확인, 공지사항…)
                </li>
                <li>RFID 카드 또는 모바일앱을Z 통한 제어</li>
                <li>
                전기/수도/조명 원격 제어, 원격 검침, 다양한 매출 보고서, 사용량 확인,
                페데스탈별 사용 현황 확인
                </li>
            </ul>
            </div>
        </div>
        <div className="pedestal">
            {imgList.map((img, index) => (
                <div className="pedestal-img" key={index}>
                    <Com.PedestalImg
                    imgUrl={img.imgUrl}
                    onClick={() => handleImgClick(img.imgUrl)}
                    />
                    <span>{img.title}</span>
                </div>
            ))}
        </div>
        {showModal && (
            <Modal onClose={() => setShowModal(false)}><img src= {showModal} alt="" style={{"width":"100%"}}/></Modal>
        )}
        </Com.DivDetailSection3>
  );
};

export default SpdstDetail;
